/**
 * RFC 9457 `application/problem+json` shape, as emitted by
 * `ApiExceptionHandler` (backend/shared-kernel/.../kernel/web/ApiExceptionHandler.java).
 */
export interface ProblemViolation {
  field: string
  code: string
  message?: string | null
}

export interface ProblemDetail {
  type?: string
  title?: string
  status: number
  detail?: string
  instance?: string
  request_id?: string
  violations?: ProblemViolation[]
}

/** Thrown by the API client for any non-2xx response. Carries the parsed problem body. */
export class ApiError extends Error {
  readonly status: number
  readonly problem: ProblemDetail

  constructor(problem: ProblemDetail) {
    super(problem.detail ?? problem.title ?? `Request failed with status ${problem.status}`)
    this.name = 'ApiError'
    this.status = problem.status
    this.problem = problem
  }

  /** True for the two optimistic-concurrency cases the UI has to special-case. */
  get isConcurrencyConflict(): boolean {
    return this.status === 409 || this.status === 412
  }
}
